import { CallingPeriodDetailsType } from '@/apis/callingstatusDateRange';
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { CallingPeriodQuantityPlaceholderValue } from '@/components/LoadSearchTemplateDialog/types';
import { FieldMetaData } from './types';

type CallingPeriodQuantityTFCProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  onChange: (value: CallingPeriodQuantityPlaceholderValue, fieldMetaData: FieldMetaData) => void;
  defaultCallingPeriodDetails?: CallingPeriodDetailsType;
  /** For Restart pre-fill */
  initialValue?: CallingPeriodQuantityPlaceholderValue;
};

export default function CallingPeriodQuantityTFC({
  onChange,
  defaultCallingPeriodDetails = 'weeks',
  initialValue,
  ...props
}: CallingPeriodQuantityTFCProps) {
  const [value, setValue] = useState(
    initialValue?.callingPeriodQuantity
      ? String(initialValue.callingPeriodQuantity)
      : ''
  );
  const [ourState, setOurState] = useState<'empty' | 'valid'>(
    initialValue?.callingPeriodQuantity ? 'valid' : 'empty'
  );
  const [callingPeriodDetails, setCallingPeriodDetails] = useState<CallingPeriodDetailsType>(
    initialValue?.callingPeriodDetails ?? defaultCallingPeriodDetails
  );
  const handleOnChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const parsedValue = parseInt(event.target.value);
    const newValue = Number.isNaN(parsedValue)
      ? Number.NaN
      : parsedValue < 0
        ? parsedValue * -1
        : parsedValue;
    setValue(isNaN(newValue) ? '' : newValue.toString());
    const ourNewState: 'empty' | 'valid' = isNaN(newValue) || newValue <= 0 ? 'empty' : 'valid';
    setOurState(ourNewState);
    onChange(
      { callingPeriodQuantity: newValue, callingPeriodDetails },
      { state: ourNewState, error: null }
    );
  };

  const handleChange = (event: SelectChangeEvent) => {
    const ourCallingPartyDetails = event.target.value as CallingPeriodDetailsType;
    setCallingPeriodDetails(ourCallingPartyDetails);
    onChange(
      { callingPeriodQuantity: Number(value), callingPeriodDetails: ourCallingPartyDetails },
      { state: ourState, error: null }
    );
  };

  return (
    <Stack direction={'row'} sx={{
      gap: '24px'
    }}>
      <FormControl variant="filled">
        <TextField
          value={value}
          onChange={handleOnChange}
          label="#*"
          placeholder=""
          inputMode="numeric"
          slotProps={{ htmlInput: { pattern: '[0-9]*' } }}
          type="text"
          sx={{ width: '100px', marginTop: '-5px' }}
          variant="filled"
          color="secondary"
          {...props}
        />
      </FormControl>
      <FormControl variant="filled">
        <Select
          color="secondary"
          value={callingPeriodDetails}
          onChange={handleChange}
          sx={{ width: '130px', marginTop: '-5px' }}
        >
          <MenuItem value={'days'}>day(s)</MenuItem>
          <MenuItem value={'weeks'}>week(s)</MenuItem>
          <MenuItem value={'months'}>month(s)</MenuItem>
          <MenuItem value={'years'}>year(s)</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
}
